export default __webpack_public_path__ + "static/media/optimistic_ethereum.34412af2.svg";